import { __extends } from "tslib";
import { ASObject } from '@awayfl/avm2';
var TextLineCreationResult = /** @class */ (function (_super) {
    __extends(TextLineCreationResult, _super);
    function TextLineCreationResult() {
        var _this = _super.call(this) || this;
        console.warn('[TextLineCreationResult] not implemented');
        return _this;
    }
    TextLineCreationResult.forceNativeConstructor = true;
    TextLineCreationResult.forceNativeMethods = true;
    // JS -> AS Bindings
    TextLineCreationResult.SUCCESS = 'success';
    TextLineCreationResult.EMERGENCY = 'emergency';
    TextLineCreationResult.COMPLETE = 'complete';
    TextLineCreationResult.INSUFFICIENT_WIDTH = 'insufficientWidth';
    return TextLineCreationResult;
}(ASObject));
export { TextLineCreationResult };
